/* eslint-disable no-console */
import { useState, useCallback, useRef } from 'react'

import { mySalesService } from '../Services/mySalesService'

export const useRefundsModal = () => {
  const [state, setState] = useState({
    isOpen: false,
    refundsData: [],
    isLoading: false,
    error: null,
  })

  const requestIdRef = useRef(0)

  const openRefundsModal = useCallback(async (refundIds) => {
    if (!refundIds || !refundIds.length) return

    requestIdRef.current += 1
    const requestId = requestIdRef.current

    setState({ isOpen: true, refundsData: [], isLoading: true, error: null })

    try {
      const response = await mySalesService.getRefunds(refundIds)
      if (requestId !== requestIdRef.current) return
      setState((prev) => ({
        ...prev,
        refundsData: Array.isArray(response) ? response : [],
        isLoading: false,
      }))
    } catch (err) {
      if (requestId !== requestIdRef.current) return
      console.error('Error fetching refunds:', err)
      setState((prev) => ({
        ...prev, error: err, refundsData: [], isLoading: false,
      }))
    }
  }, [])

  const closeRefundsModal = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: false }))
  }, [])

  return {
    refundsState: state,
    openRefundsModal,
    closeRefundsModal,
  }
}
